import React from 'react';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';

export default function HelpCenter() {
  const navigate = useNavigate();

  return (
    <div style={{ 
      padding: '40px', 
      maxWidth: '1000px', 
      margin: '0 auto',
      fontFamily: "'Inter', sans-serif"
    }}>
      {/* Header Section */}
      <div style={{ textAlign: 'center', marginBottom: '48px' }}>
        <div style={{ 
          width: '64px', 
          height: '64px', 
          backgroundColor: '#eff6ff', 
          borderRadius: '16px', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          margin: '0 auto 24px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
        }}>
          <Icon icon="ph:lifebuoy" width="32" color="#0ea5e9" />
        </div>
        <h1 style={{ 
          fontSize: '32px', 
          fontWeight: '700', 
          color: '#0f172a', 
          marginBottom: '16px',
          letterSpacing: '-0.02em'
        }}>
          Como podemos ajudar?
        </h1>
        <p style={{ color: '#64748b', fontSize: '18px', maxWidth: '600px', margin: '0 auto' }}>
          Encontre respostas, tutoriais e entre em contato com nosso suporte especializado.
        </p>

        {/* Search Bar */}
        <div style={{ 
          marginTop: '32px', 
          position: 'relative', 
          maxWidth: '500px', 
          margin: '32px auto 0' 
        }}>
          <Icon 
            icon="ph:magnifying-glass" 
            width="20" 
            color="#94a3b8" 
            style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)' }} 
          />
          <input 
            type="text" 
            placeholder="Busque por dúvidas, tópicos ou palavras-chave..." 
            style={{
              width: '100%',
              padding: '16px 16px 16px 48px',
              borderRadius: '12px',
              border: '1px solid #e2e8f0',
              fontSize: '16px',
              color: '#1e293b',
              outline: 'none',
              transition: 'all 0.2s',
              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#0ea5e9';
              e.target.style.boxShadow = '0 0 0 4px rgba(14, 165, 233, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#e2e8f0';
              e.target.style.boxShadow = '0 1px 2px 0 rgba(0, 0, 0, 0.05)';
            }}
          />
        </div>
      </div>

      {/* Categories Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px' }}>
        {[
          { 
            icon: 'ph:book-open', 
            title: 'Documentação', 
            desc: 'Guias detalhados sobre funcionalidades, configurações e primeiros passos.',
            color: '#0ea5e9',
            bg: '#f0f9ff'
          },
          { 
            icon: 'ph:play-circle', 
            title: 'Tutoriais em Vídeo', 
            desc: 'Aprenda visualmente com nossa biblioteca de vídeos passo a passo.',
            color: '#8b5cf6',
            bg: '#f5f3ff'
          },
          { 
            icon: 'ph:chat-circle-text', 
            title: 'Suporte via Chat', 
            desc: 'Converse em tempo real com nossos especialistas para resolver problemas urgentes.',
            color: '#10b981',
            bg: '#ecfdf5'
          },
          { 
            icon: 'ph:envelope-simple', 
            title: 'Fale Conosco', 
            desc: 'Envie um email para dúvidas complexas ou sugestões de melhoria.',
            color: '#f59e0b',
            bg: '#fffbeb'
          }
        ].map((item, i) => (
          <div key={i} className="help-card" style={{ 
            backgroundColor: 'white', 
            padding: '32px', 
            borderRadius: '16px', 
            border: '1px solid #e2e8f0',
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '16px'
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = 'translateY(-4px)';
            e.currentTarget.style.boxShadow = '0 12px 24px -8px rgba(0, 0, 0, 0.1)';
            e.currentTarget.style.borderColor = item.color;
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
            e.currentTarget.style.borderColor = '#e2e8f0';
          }}
          >
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              backgroundColor: item.bg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Icon icon={item.icon} width="24" color={item.color} />
            </div>
            <div>
              <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#1e293b', marginBottom: '8px' }}>{item.title}</h3>
              <p style={{ fontSize: '14px', color: '#64748b', lineHeight: '1.6' }}>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* FAQ Section */}
      <div style={{ marginTop: '64px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#0f172a', marginBottom: '24px' }}>Perguntas Frequentes</h2>
        <div style={{ display: 'grid', gap: '16px' }}>
          {[
            'Como alterar minha senha?',
            'Como integrar com WhatsApp?',
            'Quais são as taxas de saque?',
            'Como adicionar um novo usuário?'
          ].map((faq, i) => (
            <div key={i} style={{
              padding: '20px',
              backgroundColor: 'white',
              borderRadius: '12px',
              border: '1px solid #e2e8f0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f8fafc'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'white'}
            >
              <span style={{ fontSize: '16px', fontWeight: '500', color: '#334155' }}>{faq}</span>
              <Icon icon="ph:caret-right" width="20" color="#94a3b8" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
